import React from 'react'
import { Navigate, useLocation, Outlet } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { Spinner } from '@/design-system/Spinner'

/* ------------------------------------------------------------------ */
/*  RequireAuth — redirects unauthenticated users to login             */
/*  Preserves intended destination via ?next= query param              */
/*  See ARCHITECTURE.md §5                                             */
/* ------------------------------------------------------------------ */

export function RequireAuth() {
  const { isAuthenticated, isLoading } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center">
        <Spinner size={24} />
      </div>
    )
  }

  if (!isAuthenticated) {
    const next = encodeURIComponent(location.pathname + location.search)
    return <Navigate to={`/logga-in?next=${next}`} replace />
  }

  return <Outlet />
}

RequireAuth.displayName = 'RequireAuth'
